var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.loading
        ? _c("search-header", {
            attrs: {
              "total-results": _vm.pagination.totalResults,
              "search-term": _vm.search,
              filters: _vm.filters,
              "title-label": "graphic",
            },
            on: { showModal: () => (_vm.filtersDialog = true) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-card",
                    { staticClass: "mt-4", attrs: { outlined: "" } },
                    [_c("v-card-text", [_c("loading-linear")], 1)],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-row",
            _vm._l(_vm.results, function (item, key) {
              return _c(
                "v-col",
                { key: key, attrs: { sm: "3" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "fill-height",
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          return _vm.getGraphicDetails(item)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "img-block-height",
                          on: {
                            contextmenu: (event) =>
                              _vm.handleRightClick(event, item.document_sku),
                          },
                        },
                        [
                          _c(
                            "v-avatar",
                            {
                              staticStyle: {
                                position: "absolute",
                                "z-index": "2",
                                top: "2px",
                                right: "2px",
                              },
                              attrs: { color: "white", size: "40" },
                            },
                            [
                              _c("access-icon", {
                                attrs: {
                                  "access-level": _vm.getAccessLevel(
                                    item.document_sku,
                                    item.content_access_level_id
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-center" }, [
                            _c("img", {
                              attrs: {
                                src: item.figure_url,
                                alt:
                                  item.alt_text.length > 0
                                    ? item.alt_text
                                    : `${item.section_title} Graphic`,
                                height: "160px",
                              },
                              on: { error: _vm.loadPlaceholderImage },
                            }),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          item.section_title
                            ? _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c("v-col", [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "body-2 mb-0 font-weight-bold",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(item.section_title) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                [
                                  !_vm.isMobilePort
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color:
                                                              "primaryLight primary--text font-weight-bold",
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-truncate",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            " +
                                                                _vm._s(
                                                                  item.document_title
                                                                ) +
                                                                "\n                                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "tooltip-content" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.document_title) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            small: "",
                                            color:
                                              "primaryLight primary--text font-weight-bold",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-truncate" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(item.document_title) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
      _vm._v(" "),
      _vm.hasMoreResults
        ? _c(
            "v-row",
            { attrs: { dense: "", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        text: "",
                        color: "primary",
                        loading: _vm.fetchingResults,
                      },
                      on: { click: _vm.showMore },
                    },
                    [
                      _vm._v("\n                Show More\n                "),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v(
                          "\n                    mdi-chevron-down\n                "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { fullscreen: "", scrollable: "" },
          model: {
            value: _vm.filtersDialog,
            callback: function ($$v) {
              _vm.filtersDialog = $$v
            },
            expression: "filtersDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", [_vm._v("Graphics Filters")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      on: {
                        click: function ($event) {
                          _vm.filtersDialog = false
                        },
                      },
                    },
                    [_vm._v("\n                    close\n                ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pa-4" },
                [_c("graphics-search-filters")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                block: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.filtersDialog = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            Close\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }